import { createSelector } from '@ngrx/store'

export const getLicenseGenerationSettingsState = createSelector(
  (state: any) => state.licenseGenerationSettings,
  (state: any) => state,
)
